import axios from "axios";
import React, { useState, useEffect } from "react";
import OrderStats from "./OrderStats";
import OrderRevenue from "./OrderRevenue";

export default function OrdersChart() {
  const [mealrevenue, setMealRevenue] = useState(0);
  const [totalServiceFee, setTotalServiceFee] = useState(0);
  const [totalDeliveryCharges, setTotalDeliveryCharges] = useState(0);
  const [totalTips, setTotalTips] = useState(0);
  const [totalTax, setTotalTax] = useState(0);
  const [admindiscounts, setAdminDiscounts] = useState(0);
  const [totalrevenue, setTotalRevenue] = useState(0)
  const [baserevenue, setBaseRevenue] = useState(0);
  const [add_on_total, setAddOnTotal] = useState(0);
  const [chefcommission, setChefCommission] = useState(0);
  const [countryByRevenue, setCountryByRevenue] = useState([]);

  const getDashboardData = async () => {
    const revenue = await axios.get("/api/calculations/revenue/");

    const {
      mealrevenue,
      totaldelivery,
      totalservicefee,
      tips,
      baserevenue,
      base_commission,
      taxes,
      discount,
      add_on_total,
      add_on_commission,
    } = revenue.data;
    setCountryByRevenue(revenue.data)
    setMealRevenue(mealrevenue);
    setTotalDeliveryCharges(totaldelivery);
    setTotalServiceFee(totalservicefee);
    setTotalTips(tips);
    setTotalTax(taxes);
    setAdminDiscounts(discount);
    setBaseRevenue(baserevenue);
    let chefcommission =
      parseFloat(base_commission) + parseFloat(add_on_commission);
    setChefCommission(chefcommission);
    setAddOnTotal(add_on_total);
  }

  useEffect(() => {
    let mounted = true;
    getDashboardData();
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <>
      <div className="row">
        <div className="col-lg-6">
          <OrderStats />
        </div>
        <div className="col-lg-6">
          <OrderRevenue revenue={countryByRevenue} />
        </div>
      </div>
      <div className="row">
        <div className="col-lg-6">
          <div className="ibox">
            <div className="ibox-title">
              <h5>
                Commission Revenue ${parseFloat(chefcommission).toFixed(2)}
              </h5>
            </div>
            <div className="ibox-content">
              <div className="row justify-content-between mt-1">
                <div className="card col-lg-6 bg-success">
                  <div className="card-body">
                    <h5 className="text-white">Base Price</h5>
                    <h1 className="no-margins">${baserevenue}</h1>
                  </div>
                </div>

                <div className="card col-lg-6 bg-danger">
                  <div className="card-body">
                    <h5 className="text-white">Add Ons</h5>
                    <h1 className="no-margins">${add_on_total}</h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="col-lg-6">
          <div className="ibox">
            <div className="ibox-title">
              <h5>Campaign Revenue($)</h5>
            </div>
            <div className="ibox-content">
              <div className="row justify-content-between mt-1">
                <div className="card col-lg-12 bg-success">
                  <div className="card-body">
                    <h5 className="text-white">Banner Marketing</h5>
                    <h1 className="no-margins">$0</h1>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="row mx-1">
        <div className="ibox col-12">
          <div className="ibox-title">
            <h5>Feasti Revenue ${parseFloat(baserevenue * 0.1).toFixed(2)}</h5>
          </div>
          <div className="ibox-content">
            <div className="row justify-content-between mt-1">
              <div className="card bg-success">
                <div className="card-body">
                  <h5 className="text-white">Net Income</h5>
                  <h1 className="no-margins">
                    $
                    {parseFloat(
                      mealrevenue -
                      baserevenue +
                      0.1 * baserevenue +
                      totalDeliveryCharges +
                      totalServiceFee +
                      totalTax +
                      totalTips -
                      admindiscounts
                    ).toFixed(2)}
                  </h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
